import { ExtraAppValue } from "../../../services/api/instances/extraAppApi/types";
import { StorageObject } from "../../../services/api/instances/storageApi/types/object_types";
import { TDeerFlowInstance } from "../redux/types";
import { getDeerFlowInstanceOrigin } from "./getDeerFlowInstanceUrl";

const DFA_AGENT_PATTERN = /^https:\/\/dfagent-instance-/;

export function filterByDfAgentUri(
  items: StorageObject<ExtraAppValue>[],
): TDeerFlowInstance[] {
  const result: TDeerFlowInstance[] = [];

  for (const item of items) {
    const uri = item.value?.extra_app_object?.uri;

    if (uri && DFA_AGENT_PATTERN.test(uri)) {
      result.push({
        id: item.id,
        name: item.friendly_name,
        url: getDeerFlowInstanceOrigin(uri),
      });
    }

    if (item.children?.length) {
      result.push(...filterByDfAgentUri(item.children));
    }
  }

  return result;
}
